<div class="permit_listing_page">
    <div class="col-md-12" *ngIf="isLoading">
      <app-busy [message]="message"></app-busy>
    </div>
    <div *ngIf="!isExternalRole">
      <div  class="back">
        <img src="../../../../../assets/newimg/arrow-1-3@2x.png"  (click)="onBack()" style="cursor: pointer;margin: 10px;"/>
      </div>
      <h3>{{permits?.carrier?.name}}</h3>
    </div>
  
    <ng-template #select let-modal>
      <div class="modal-body">
        <app-choose-carrier
          [userId]="user.Id"
          (onAction)="onModalAction($event)"
        ></app-choose-carrier>
      </div>
    </ng-template>
    <div class="col-1 btn-show">
      <span
        title="Apply filters..."
        id="btnSearch"
        (click)="onSearch()"
        class="btn btn_primary btn-md"
        style="margin-right: 4px !important;display: none;"
        ><i class="fa fa-search" aria-hidden="true" ></i
      ></span>
     
      <span
        (click)="onReset()"
        title="Reset filters..."
        id="resetMonthlyComplianceFilter"
        class="btn btn_primary btn-md"
        style="margin-right: 4px !important;display: none;"

        ><i class="fa fa-undo" aria-hidden="true"></i
      ></span>
    </div>
    
   
  
    <ng-container>
      <div class="page_header">
        <h1 class="heading">Monthly Compliance</h1>
        <p class="name">{{ user?.UserName }}</p>
      </div>
  
      <ng-container>
        <app-filter
          [formConfig]="filterConfig"
          (formValueChanged)="applyFilter($event)"
        ></app-filter>
      </ng-container>
      <div class="table-responsive" >
        <table class="table custom_table">
          <thead>
          
            <th>Permit Number</th>
            <th>Permit Type</th>
            <th>Expiry</th>
            <th>Border Crossing</th>
            <th *ngFor="let month of months">{{ month }}</th>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let permit of permits
                  | paginate
                    : {
                        itemsPerPage: pageSize,
                        currentPage: currentPage,
                        totalItems: count
                      };
                let i = index
              "
            >
             
            <tr *ngFor="let permit of permits">
              <td>{{ permit.permit_num }}</td>
              <td>{{ permit.description }}</td>
              <td>{{ permit.date_valid_to | date : 'dd/MM/yyyy' }}</td>
              <td>{{ permit.name }}</td>
              <td *ngFor="let month of months">
                <ng-container *ngIf="hasMonthlyData(permit, month); else noStatus">
                  <ng-container *ngFor="let monthlyData of permit.MonthlyData">
                    <ng-container *ngIf="getMonthFromDate(monthlyData.yyyy_mm) === month">
                    <ng-container [ngSwitch]="monthlyData.status_ind">
                      <span *ngSwitchCase="1">
                        
                        <a    style="color: #00008b; text-decoration: underline" (click)=navigate(carrierId,permit.permit_id,monthlyData.compliance_id)><u>No</u></a>
                      </span>
                      <span *ngSwitchCase="51">
                        <a    style="color: #00008b; text-decoration: underline"(click)=navigate(carrierId,permit.permit_id,monthlyData.compliance_id)><u>Yes</u></a>
                      </span>
                      <span *ngSwitchCase="21">
                        <a  style="color: #00008b; text-decoration: underline"(click)=navigate(carrierId,permit.permit_id,monthlyData.compliance_id)><u>No</u></a>
                      </span>
                      <span *ngSwitchCase="11">
                        <a   style="color: #00008b; text-decoration: underline"(click)=navigate(carrierId,permit.permit_id,monthlyData.compliance_id)><u>No</u></a>
                      </span>
                      
                <span *ngSwitchDefault>No Status</span>
                      </ng-container>
                    </ng-container>
                  </ng-container>
                </ng-container>
                <ng-template #noStatus>
                  N/A
                </ng-template>
              </td>
            </tr>
          </tbody>
          <tfoot>
            <tr  class="pagination_row">
              <td colspan="12" class="rm-brd">
                <div class="row">
                  <div class="col-2">
                    <div
                      class="input-group mb-3 rm-brd"
                      style="width: 125px !important; height: 30px !important"
                    >
                      <div class="input-group-prepend">
                        <label
                          class="input-group-text form-control-sm show-h"
                          for="show-id"
                          >Show:</label
                        >
                      </div>
                      <select
                        class="form-control form-control-sm show-h"
                        id="show-id"
                        [(ngModel)]="pageSize"
                  (change)="onChange(pageSize)"
                      >
                        <option
                          *ngFor="let key of utility.pageItems"
                          [ngValue]="key"
                        >
                          {{ key }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="col-10">
                    <pagination-controls
                      (pageChange)="utility.page = onNextOrPrevious($event)"
                      style="margin-right: 0px !important; float: right !important"
                    ></pagination-controls>
                  </div>
                </div>
              </td>
            </tr>
           
          </tfoot>
        </table>
      </div>
    </ng-container>
  
   
  </div>
